import { Button, Modal } from 'antd';
import styled, { css } from 'styled-components';

// ========== TPSL Modal 스타일 ==========
export const TPSLModal = styled(Modal)`
  .ant-modal-close {
    width: 16px;
    height: 16px;
    top: 24px;
    right: 24px;
  }
`;

export const PriceInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
  background-color: #2a2c2e;
  border-radius: 6px;
  padding: 16px 20px;
  margin-bottom: 20px;
`;

export const PriceInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const PriceInfoLabel = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
  color: #b3b5bd;
`;

export const PriceInfoValue = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: -0.36px;
  color: #ffffff;
`;

export const TPSLSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TPSLInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TPSLLabel = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
  color: #b3b5bd;
`;

export const TPSLInputRow = styled.div`
  display: flex;
  gap: 4px;
`;

export const TPSLInput = styled.div<{ $width?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #2a2c2e;
  border-radius: 6px;
  height: 38px;
  padding: 4px 12px;
  width: ${({ $width }) => $width || '240px'};
  flex: ${({ $width }) => ($width === 'flex' ? 1 : 'none')};

  input {
    background: transparent;
    border: none;
    outline: none;
    color: #ffffff;
    font-family: 'NanumSquareRound', sans-serif;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: -0.24px;
    width: 100%;

    &::placeholder {
      color: #777986;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const TPSLInputSuffix = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: -0.24px;
  color: #b3b5bd;
  white-space: nowrap;
`;

export const TPSLButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
`;

export const TPSLCancelButton = styled.button`
  flex: 1;
  height: 38px;
  border-radius: 12px;
  border: 1px solid #353535;
  background-color: transparent;
  color: #ffffff;
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #07d993;
  }
`;

export const TPSLSaveButton = styled.button`
  flex: 1;
  height: 48px;
  border-radius: 12px;
  border: none;
  background-color: #07d993;
  color: #0d1117;
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0px 2px 12px 0px rgba(7, 217, 147, 0.6);
  }
`;

export const TPSLDeleteButton = styled.button`
  flex: 1;
  height: 48px;
  border-radius: 12px;
  border: 1px solid #ff4d4f;
  background-color: transparent;
  color: #ff4d4f;
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(255, 77, 79, 0.1);
  }
`;

// ========== BottomSheet 스타일 ==========
export const BottomSheetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 12px;
`;

export const BottomSheetTitle = styled.h2`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.32px;
  color: #ffffff;
  margin: 0;
`;

export const BottomSheetBody = styled.div`
  padding: 0 12px 32px 12px;
`;
// ========== BottomSheet 스타일 끝 ==========

// ========== TPSL Modal 스타일 끝 ==========

export const TradeDetailContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: visible;
  /* background-color: ${(props) => props.theme.COLORS.drawerBgColor}; */

  & * ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  .widgetClose {
    display: none;
  }

  &:hover {
    .widgetClose {
      display: flex;
    }
  }

  @media (max-width: 900px) {
    height: 500px;
  }
  overflow: hidden;
`;
export const TradeDetailHeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 10px;
  padding-top: 5px;
  padding-bottom: 0;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.tableDivider};
`;

export const TradeDetailNavBarSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 10px;
  padding-bottom: 0;
`;
export const TradeDetailListsWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
`;

export const TPSLEDITButton = styled(Button)<{ $isMobile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(53, 53, 53);
  color: rgb(179, 181, 189);
  font-size: 12px;
  border-radius: 4px;
  line-height: 1;
  font-weight: 400;
  font-family: NanumSquareRound, sans-serif;
  background: transparent;

  ${({ $isMobile }) =>
    $isMobile &&
    css`
      margin-left: 10px;
      background: transparent;
      color: rgb(179, 181, 189);
      min-height: 30px;
    `}

  &:hover,
  &:focus {
    border: 1px solid rgb(102, 102, 104) !important;
    color: #fff !important;
    background: transparent !important;
  }
`;
